document.addEventListener('DOMContentLoaded', () => {
  const generateSvgButton = document.querySelector('#generate-pdf-link');
  const addToCartButton = document.querySelector('button[data-js-product-add-to-cart]');
  const overlay = document.createElement('div');
  overlay.id = 'interaction-blocker';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
  overlay.style.zIndex = '99999';
  overlay.style.display = 'none';
  document.body.appendChild(overlay);
  
  if (generateSvgButton) {
    generateSvgButton.addEventListener('click', async (event) => {
      console.log("Generate SVG button clicked");
      event.preventDefault();
      event.stopPropagation();
      
      const spinner = document.createElement('span');
      spinner.className = 'spinner';
      generateSvgButton.appendChild(spinner);
      generateSvgButton.disabled = true;
      overlay.style.display = 'block';
      
      try {
        // Hole die SKU-Nummer aus dem entsprechenden Element
        const skuElement = document.getElementById('sku');
        const sku = skuElement ? skuElement.textContent.trim() : 'unknown';
        
        // Hole die ausgewählte Farbe aus den Radio-Buttons
        const selectedColorElement = document.querySelector('.color-picker__item input:checked');
        let selectedColor = 'unknown';
        
        if (selectedColorElement) {
          // Wenn ein Radio-Button ausgewählt ist, nehme dessen Label
          const colorLabel = selectedColorElement.closest('.color-picker__item').querySelector('.color-picker__label');
          if (colorLabel) {
            selectedColor = colorLabel.textContent.trim();
          }
        } else {
          // Fallback: Prüfe, ob es eine aktive Farbauswahl gibt (für den Fall, dass keine Radio-Buttons verwendet werden)
          const activeColorItem = document.querySelector('.color-picker__item.active');
          if (activeColorItem) {
            const colorLabel = activeColorItem.querySelector('.color-picker__label');
            if (colorLabel) {
              selectedColor = colorLabel.textContent.trim();
            }
          }
        }
        
        // Hole Breite und Höhe aus den Input-Feldern
        const widthInput = document.getElementById('svgWidth');
        const heightInput = document.getElementById('svgHeight');
        
        const width = widthInput ? widthInput.value : 'unknown';
        const height = heightInput ? heightInput.value : 'unknown';
        
        // Hole das SVG-Element
        const svgElement = document.getElementById('svg-path');
        if (!svgElement) {
          throw new Error("SVG element not found");
        }
        
        // Erstelle eine Kopie des SVG-Elements für den Upload
        const svgClone = svgElement.cloneNode(true);
        
        // Serialisiere das SVG für den Upload
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svgElement);
        const blob = new Blob([svgString], { type: "image/svg+xml" });
        const fileName = `${sku}_${selectedColor}_${width}x${height}_${generateRandomId(8)}.svg`;
        
        const pdfUrl = await sendToServer(blob, fileName, sku, selectedColor, width, height);
        if (pdfUrl) {
          setSvgInputValue(pdfUrl);
        }
      } catch (error) {
        console.error('Error generating SVG:', error);
        alert('There was an error generating the SVG. Please try again.');
      } finally {
        spinner.remove();
        generateSvgButton.disabled = false;
        overlay.style.display = 'none';
        if (addToCartButton) {
          addToCartButton.click();
        }
      }
    });
  } else {
    console.error('Generate SVG button not found.');
  }
  
  function generateRandomId(length = 8) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
  }
  
  async function sendToServer(svgBlob, fileName, sku, color, width, height) {
    const formData = new FormData();
    formData.append('svgFile', svgBlob, fileName);
    formData.append('sku', sku);
    formData.append('color', color);
    formData.append('width', width);
    formData.append('height', height);
    
    const response = await fetch('https://design.my-foil.ch/mw-cloud-convert-svg-pdf.php', {
      method: 'POST',
      body: formData,
    }).catch(error => {
      console.error('Network error:', error);
      alert('There was a network error while uploading the SVG. Please try again.');
      return null;
    });
    
    if (response && response.ok) {
      const data = await response.json();
      console.log('Server Response:', data);
      if (data && data.pdf_link) {
        return data.pdf_link;
      } else {
        console.error('PDF URL not found in the server response:', data);
      }
    }
    return null;
  }
  
  function setSvgInputValue(pdfUrl) {
    const svgInput = document.getElementById('pdf_link');
    if (svgInput) {
      svgInput.value = pdfUrl;
    } else {
      console.error('PDF input field not found');
    }
  }
});